import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1252672"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-padding-horizontal" }
const _hoisted_2 = {
  key: 0,
  class: "challenge-image"
}
const _hoisted_3 = { class: "progress-info" }
const _hoisted_4 = {
  class: "ion-align-items-center ion-justify-content-between",
  style: {"display":"flex"}
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  class: "ion-align-items-center ion-justify-content-between",
  style: {"display":"flex"}
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "ion-margin-top buttons" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "end" }, "Challenge abbrechen", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "end" }, "An Challenge teilnehmen", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { slot: "end" }, "Challenge ablehnen", -1))

import {ref, computed, onMounted, watch} from "vue";
import {
  IonButton, IonBackButton,
  IonButtons,
  IonIcon,
  IonProgressBar,
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle, alertController, toastController,
  IonImg
} from '@ionic/vue';
import * as icons from 'ionicons/icons';
import useChallenge from "@/composable/useChallenge";
import {Challenge} from "@/mobipoints/challenge/challenge/challenge.type";
import {RouteParams, useRoute} from "vue-router";
import router from "@/router";
import {
  CHALLENGE_STATE_IN_PROGRESS
} from "@/mobipoints/challenge/challenge/challenge.interface";
import {
  USER_CHALLENGE_STATE_ACCEPTED,
  USER_CHALLENGE_STATE_CANCELLED, USER_CHALLENGE_STATE_DECLINED, USER_CHALLENGE_STATE_FINISHED
} from "@/mobipoints/challenge/userChallenge/user_challenge.interface";
import store from "@/store";
import ChallengeHighscore from "@/components/challenge/ChallengeHighscore.vue";
import {UserChallenge} from "@/mobipoints/challenge/userChallenge/user_challenge.type";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {ChallengeResponseError} from "@/mobipoints/api/challenge";
import {MobiPointsLocationTypes} from "@/mobipoints/location/location_type.interface";
import useMainData from "@/composable/useMainData";
import useData from "@/composable/useData";


const refreshTimeout = 10;  //  in seconds

export default /*#__PURE__*/_defineComponent({
  __name: 'ChallengeDetail',
  setup(__props, { expose: __expose }) {

const currentRoute = useRoute();
const mainData = useMainData();
const {getTextValueByKey} = useData();

// const currentRouteName = ref<string>(String(currentRoute.name));
const currentRouteParams = ref<RouteParams>(currentRoute.params || {});
const backButtonText = ref(getTextValueByKey('overview.back.button.text', [], ''));


const hasHomeLocation = computed<boolean>(() => {
  const homeLocations = mainData.userLocationsEditable.value.filter((userLocation) => MobiPointsLocationTypes.HOME_LOCATION === userLocation.type.code);
  return homeLocations.length > 0;
});

const showDefineHomeLocationInfo = computed<boolean>(() => {
  return !hasHomeLocation.value;
});

const challengeUuid = computed<string>(() => {
  return String(currentRouteParams.value && currentRouteParams.value.uuid);
});

const hasUserChallengeAccepted = computed<boolean>(() => {
  return null !== userChallenge.value && (
    USER_CHALLENGE_STATE_ACCEPTED === userChallenge.value.state.code
    || USER_CHALLENGE_STATE_FINISHED === userChallenge.value.state.code
  );
});

const hasUserChallengeCancelled = computed<boolean>(() => {
  return null !== userChallenge.value && USER_CHALLENGE_STATE_CANCELLED === userChallenge.value.state.code;
});

const hasUserChallengeDeclined = computed<boolean>(() => {
  return null !== userChallenge.value && USER_CHALLENGE_STATE_DECLINED === userChallenge.value.state.code;
});

const hasUserChallenge = computed<boolean>(() => {
  return null !== userChallenge.value;
});

const userChallenge = computed<UserChallenge | null>(() => {
  return (challenge.value && challenge.value.userChallenges[0] as UserChallenge) || null;
});

const userChallengeProgress = computed<number>(() => {
  return userChallenge.value?.progress || 0;
});

const userChallengeProgressPercentage = computed<number>(() => {
  return userChallengeProgress.value / 100;
});

const challengeInfo = computed<string>(() => {
  const createHomeLocationInfo = getTextValueByKey('challenge.detail.createHomeLocationInfo');
  return (challenge.value && challenge.value.description || '').replace(createHomeLocationInfo, '');
});

const timeInfo = computed<string>(() => {
  const timeStr = challenge.value?.getTimeLeftAsString() || '';
  if (timeStr.length > 0) {
    return getTextValueByKey('challenge.detail.timeInfo', [{'key': 'time', 'value': timeStr}], '');
  } else {
    return '';
  }
});


const createToast = function (message: string, icon: string, duration = 3000, position: 'top' | 'bottom' | 'middle' = 'bottom'): Promise<any> {
  return toastController.create({
    message: message,
    position: position,
    duration: duration > 0 ? duration : 3000,
    icon: icon,
    buttons: [
      {
        side: 'end',
        role: 'cancel',
        icon: icons.close,
      }
    ],
  });
}


const acceptChallenge = async function () {
  if (null !== challenge.value) {
    const result: string | null = await store.dispatch('challenge/acceptChallenge', challenge.value.uuid);
    let message: string;
    let icon = icons.checkmarkOutline;
    if (null === result) {
      challenge.value = challengeFacade.getChallenge(challengeUuid.value);
      message = `Ab sofort nimmst du an der Challenge teil!`;
    } else {
      message = `Could not accept challenge: ${result || 'Unkown'}`;
      icon = icons.warning;
    }

    return (await createToast(message, icon)).present();
  }
}

const cancelChallenge = async function () {
  if (null !== challenge.value) {
    const result: string | null = await store.dispatch('challenge/cancelChallenge', challenge.value.uuid);
    let message: string;
    let icon = icons.checkmarkOutline;
    if (null === result) {
      challenge.value = challengeFacade.getChallenge(challengeUuid.value);
      message = `Du hast die Teilnahme an der Challenge abgebrochen!`;
    } else {
      message = `Could not cancel challenge: ${result || 'Unkown'}`;
      icon = icons.warning;
    }

    return (await createToast(message, icon)).present();
  }
}

const declineChallenge = async function () {
  if (null !== challenge.value) {
    const alert = await alertController.create({
      header: 'Sicherheitsabfrage:',
      message: 'Die Teilnahme an der Challenge wirklich ablehnen<br>(Eine spätere Teilnahme ist nicht mehr möglich)?',
      buttons: [
        {
          text: 'Nein',
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: 'Ja',
          cssClass: 'danger',
          handler: async function () {
            if (null !== challenge.value) {
              const result: string | null = await store.dispatch('challenge/declineChallenge', challenge.value.uuid);
              let message: string;
              let icon = icons.checkmarkOutline;
              if (null === result) {
                challenge.value = challengeFacade.getChallenge(challengeUuid.value);
                message = `Du hast die Teilnahme an der Challenge abgelehnt!`;
              } else {
                message = `Could not decline challenge: ${result || 'Unkown'}`;
                icon = icons.warning;
              }

              const toast = await createToast(message, icon);
              toast.present().then(router.replace({ name: 'Challenges' }));
            }
          }
        }
      ]
    });

    return alert.present();
  }
}

const challengeFacade = useChallenge();

onMounted(() => {
  if (null === challenge.value || CHALLENGE_STATE_IN_PROGRESS !== challenge.value.state.code) {
    router.back();
  }
  // challengeFacade.reloadChallenges().then(() => {
  //   challenge.value = challengeFacade.getChallenge(challengeUuid.value);
  // });
});


const challenge = ref<Challenge | null>(challengeFacade.getChallenge(challengeUuid.value));

let lastRefresh = Date.now();
let nextRefreshTO: number;
let resetRefreshColorTO: number;

const refreshIcon = ref<string>(icons.refreshOutline);
const refreshColor = ref<string>('');
const doRefresh = async function() {
  try {
    await challengeFacade.reloadChallenges();

    lastRefresh = Date.now();

    refreshIcon.value = icons.refreshOutline;
    refreshColor.value = 'success';

    clearTimeout(resetRefreshColorTO);
    resetRefreshColorTO = setTimeout(() => {
      refreshColor.value = '';
    }, refreshTimeout * 1000);

    const toast = await createToast(`Seite erfolgreich aktualisiert!`, icons.checkmarkOutline, 1500, 'bottom');
    return toast.present();
  } catch (error: any | ChallengeResponseError) {
    lastRefresh = Date.now();

    refreshColor.value = 'danger';

    const toast = await createToast(`Seite konnte nicht aktualisiert werden!`, icons.bugOutline, 3000, 'bottom');
    return toast.present();
  }
}
const refresh = async function () {
  const diff = (Date.now() - lastRefresh) / 1000;
  if (diff < refreshTimeout) {
    const toast = await createToast(`Noch ${Math.ceil(refreshTimeout - diff)} Sekunden bis zum nächsten Reload`, icons.informationOutline, 2000, 'top');

    clearTimeout(nextRefreshTO);
    nextRefreshTO = setTimeout(doRefresh, (refreshTimeout - diff) * 1000);
    refreshIcon.value = icons.timerOutline;
    refreshColor.value = 'primary';

    return toast.present();
  }
  await doRefresh();
}

watch(() => challengeFacade.getChallenge(challengeUuid.value), async (newChallenge) => {
  if (challengeUuid.value === newChallenge?.uuid) {
    challenge.value = newChallenge;
  }
});

__expose({});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    defaultHref: "/tabs/challenges",
                    text: backButtonText.value
                  }, null, 8, ["text"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonButtons), { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (refresh()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            icon: refreshIcon.value,
                            color: refreshColor.value
                          }, null, 8, ["icon", "color"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("Challenges")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (null !== challenge.value)
        ? (_openBlock(), _createBlock(_unref(IonContent), {
            key: 0,
            fullscreen: true
          }, {
            default: _withCtx(() => [
              _createElementVNode("section", _hoisted_1, [
                _createElementVNode("div", null, [
                  _createElementVNode("h1", null, _toDisplayString(challenge.value.title), 1),
                  (challenge.value.getImage())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_unref(IonImg), {
                          alt: challenge.value.getImage(),
                          src: challenge.value.getImage()
                        }, null, 8, ["alt", "src"]),
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", null, _toDisplayString(userChallengeProgress.value) + "%", 1),
                            _withDirectives(_createVNode(_unref(IonIcon), {
                              icon: icons.checkmarkOutline,
                              style: {"margin-left":".25em"}
                            }, null, 8, ["icon"]), [
                              [_vShow, userChallengeProgress.value >= 100]
                            ]),
                            _withDirectives(_createVNode(_unref(IonIcon), {
                              icon: icons.pauseOutline,
                              style: {"margin-left":".25em"}
                            }, null, 8, ["icon"]), [
                              [_vShow, hasUserChallengeCancelled.value]
                            ])
                          ]),
                          _createVNode(_unref(IonProgressBar), {
                            value: userChallengeProgressPercentage.value,
                            color: "secondary"
                          }, null, 8, ["value"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", null, _toDisplayString(userChallengeProgress.value) + "%", 1),
                          _withDirectives(_createVNode(_unref(IonIcon), {
                            icon: icons.checkmarkOutline,
                            style: {"margin-left":".25em"}
                          }, null, 8, ["icon"]), [
                            [_vShow, userChallengeProgress.value >= 100]
                          ]),
                          _withDirectives(_createVNode(_unref(IonIcon), {
                            icon: icons.pauseOutline,
                            style: {"margin-left":".25em"}
                          }, null, 8, ["icon"]), [
                            [_vShow, hasUserChallengeCancelled.value]
                          ])
                        ]),
                        _createVNode(_unref(IonProgressBar), {
                          value: userChallengeProgressPercentage.value,
                          color: "secondary"
                        }, null, 8, ["value"])
                      ]))
                ]),
                (hasUserChallengeAccepted.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      innerHTML: timeInfo.value,
                      class: "time-info"
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true),
                _createElementVNode("p", { innerHTML: challengeInfo.value }, null, 8, _hoisted_8),
                (showDefineHomeLocationInfo.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: "location-info",
                      innerHTML: _unref(getTextValueByKey)('challenge.detail.createHomeLocationInfo')
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  (hasUserChallengeAccepted.value)
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 0,
                        color: "warning",
                        expand: "block",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (cancelChallenge()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: icons.pauseOutline,
                            style: {"margin-right":".25em"}
                          }, null, 8, ["icon"]),
                          _hoisted_11
                        ]),
                        _: 1
                      }))
                    : (hasUserChallengeCancelled.value || !hasUserChallengeDeclined.value)
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 1,
                          color: "success",
                          expand: "block",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (acceptChallenge())),
                          class: "ion-margin-bottom"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), {
                              slot: "start",
                              icon: icons.checkmarkOutline,
                              size: "large",
                              style: {"margin-right":".25em"}
                            }, null, 8, ["icon"]),
                            _hoisted_12
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                  (!hasUserChallengeDeclined.value && !hasUserChallenge.value)
                    ? (_openBlock(), _createBlock(_unref(IonButton), {
                        key: 2,
                        size: "small",
                        color: "danger",
                        expand: "block",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (declineChallenge()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), {
                            slot: "start",
                            icon: icons.closeOutline,
                            style: {"margin-right":".25em"}
                          }, null, 8, ["icon"]),
                          _hoisted_13
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(ChallengeHighscore, { uuid: challengeUuid.value }, null, 8, ["uuid"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})